import React, { ComponentType } from 'react';
import Layout from 'src/components/Layout/Layout';

interface WithLayoutProps {
  title: string;
}

export const withLayout = <P extends WithLayoutProps>(
  Component: ComponentType<P>
): React.FunctionComponent<P> => {
  return function WithLayout(props: P): JSX.Element {
    const { title, ...rest } = props;

    return (
      <Layout title={title}>
        <Component {...(rest as P)} />
      </Layout>
    );
  };
};

export default withLayout;
